import { cn } from '@/utils/cn'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  label?: string
}

const sizeClasses = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-3',
}

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <div
      role="status"
      className={cn('inline-flex flex-col items-center justify-center gap-3', className)}
      aria-label={label ?? 'Carregando'}
    >
      <div
        className={cn(
          'rounded-full border-[var(--border-medium)] border-t-[var(--color-brand)] animate-spin',
          sizeClasses[size],
        )}
      />
      {label && (
        <span className="text-sm text-[var(--text-muted)]">{label}</span>
      )}
    </div>
  )
}

export function PageSpinner({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[200px]">
      <Spinner size="lg" label={label} />
    </div>
  )
}
